// IE 2026 10 29 / ODOO-5800 (ie-dm7 #114897: плашка «Порівняння з» — _compare_info.compare_model)
// Плашка «Compared with: …» чипса сравнения отчёта: с чем сравнивается отчёт СЕЙЧАС (по умолчанию — со вчерашней копией, а не с ПМ 1 сентября).
// Источник — doc._compare_info.compare_model = { pm_id, kind, date, title, reason, mode } (бэк, select_compare / select с compare);
// режим mode = doc.params.compare_model_mode: yesterday | prev_month | latest_archive | explicit.   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115178: режим модели сравнения — compare_model_mode, compare_mode = rows|union не трогаем)
// Чистые функции без Vue: payload → { visible, ... }, текст собирается с переданным t (по умолчанию — подстановка без перевода).

const str = (v) => (v == null ? '' : String(v).trim())
// t по умолчанию — без перевода, но с подстановкой {имя}
const plain = (s, v) => (v ? String(s).replace(/\{(\w+)\}/g, (m, k) => (v[k] == null ? m : String(v[k]))) : s)

export const CMP_MODES = ['yesterday', 'prev_month', 'latest_archive', 'explicit']

// 2026-10-28 / 2026-10-28T03:00:00 → «28.10.2026»; не ISO — как есть
export function compareModelBadge_date(date) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str(date))
    return m ? m[3] + '.' + m[2] + '.' + m[1] : str(date)
}

// payload — doc._compare_info; visible — только когда compare_model есть и по нему можно назвать, с чем сравнение
export function compareModelBadge(payload) {
    const cm = payload && typeof payload === 'object' && payload.compare_model && typeof payload.compare_model === 'object' ? payload.compare_model : null
    const none = { visible: false, copy: false, date: '', title: '', mode: '', reason: '', pmId: '' }
    if (!cm) return none
    const kind = str(cm.kind), date = compareModelBadge_date(cm.date), title = str(cm.title), pmId = str(cm.pm_id)
    const copy = kind === 'archive' && !!date                  // архивная копия называется по дате; без даты — по названию
    if (!copy && !title && !pmId) return none
    const mode = CMP_MODES.includes(str(cm.mode)) ? str(cm.mode) : ''
    return { visible: true, copy, date, title: title || pmId, mode, reason: str(cm.reason), pmId }
}

// «copy 28.10.2026» / название модели
export function compareModelBadge_what(b, t = plain) {
    if (!b || !b.visible) return ''
    return b.copy ? t('copy {date}', { date: b.date }) : b.title
}

// суффикс режима: yesterday → «(yesterday)», … ; explicit и неизвестный режим — без суффикса
export function compareModelBadge_suffix(b, t = plain) {
    switch (b && b.mode) {
        case 'yesterday': return t('(yesterday)')
        case 'prev_month': return t('(previous month)')
        case 'latest_archive': return t('(latest copy)')
        default: return ''
    }
}

// «Compared with: copy 28.10.2026 (yesterday)»; '' — плашки нет
export function compareModelBadge_text(payload, t = plain) {
    const b = compareModelBadge(payload)
    if (!b.visible) return ''
    const what = compareModelBadge_what(b, t), suffix = compareModelBadge_suffix(b, t)
    return t('Compared with: {what}', { what: suffix ? what + ' ' + suffix : what })
}

// IE 2026 10 29 / ODOO-5800 (ie-dm7 #114897, проба p089d: причина выбора копии — словами, не кодом BE)
// код причины BE (compare_model.reason) → английская фраза для t(); незнакомый код — как есть
export const COMPARE_MODEL_REASONS = {
    report_model: "it is the model set in the report",
    yesterday: "it is yesterday's nightly copy of the current model",
    earlier: "there is no copy from yesterday, so the latest earlier copy is used",
    latest: "it is the latest copy of the current model",
    no_archive: "the current model has no copies yet",
    branch: "it is the model this branch was made from",
    prev_month: "it is the model of the previous month",
    flag_off: "automatic choice is off, the model set in the report is used",
    explicit_empty: "no model is set in the report",
}
// переменные для объяснения по Alt (uiHelp 'chips.chip.compare'): what — с чем сравнивается, reason — почему именно эта копия (строка бэка)
export function compareModelBadge_helpVars(payload, t = plain) {
    const b = compareModelBadge(payload)
    if (!b.visible) return {}
    const what = compareModelBadge_what(b, t), suffix = compareModelBadge_suffix(b, t)
    const rs = COMPARE_MODEL_REASONS[b.reason]   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114897, проба p089d: причина выбора копии — словами, не кодом BE)
    return { what: suffix ? what + ' ' + suffix : what, reason: rs ? t(rs) : b.reason }
}
